module.exports = __webpack_public_path__ + "static/media/linkGif.35a2c236.gif";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Artist/static/images/linkGif.gif
// module id = 114
// module chunks = 1